export const externalUserTextLinkStyles: React.CSSProperties = {
  marginTop: '10px'
};